export default __webpack_public_path__ + "static/media/Privacy-Policy.1fecba60.jpg";